import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GraphqlService } from './graphql.service';
import { Injectable } from '@angular/core';
import { MetaInfoSchema } from '../schemas/meta-info.schema';

@Injectable()
export class MetaInfoService extends GraphqlService {
	/**
	 * Gets the current server time.
	 */
	GetServerTime(): Observable<Date> {
		return this.query(MetaInfoSchema.serverTime).pipe(map((response: any) => response.servermetainfo.serverTime));
	}
}
